<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo" />
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">Alterar Dados da Turma</p>
                <div class>
                  <div class id="tabela-turmas">
                    <section id="turma-dashboard" class="column">
                      <section id="entity-content">
                        <turma-form :formtitle="'Alterar Dados da Turma'" :turma="turma" @formSubmit="update" buttom="Salvar turma" />
                      </section>
                    </section>
                  </div>
                </div>
              </div>
              <internfooter />
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TurmaService from "@/services/TurmaService";
import TurmaForm from "@/components/AdminView/Turma/Form";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";

export default {
  props: [],
  methods: {
    update(turma) {
      this.isLoading = true;
      TurmaService.Update(this.$route.params.uuid, turma)

        .then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "update realizado com sucesso!",
            position: "is-top-right",
            type: "is-success"
          });
          this.$router.push({ name: "admin/turma" });
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    TurmaForm: TurmaForm
  },
  data() {
    return {
      turma: {
        nome: "",
        escola_id: ""
      }
    };
  },
  created() {
    TurmaService.Info(this.$route.params.uuid).then(result => {
      this.turma = result.data;
    });
  }
};
</script>